import { StateCreator } from 'zustand';

import { handleResetState, handleSetPlatform } from './handlers';
import { INITIAL_PLATFORM_STATE, PlatformStore } from './types';

export const createPlatformSlice: StateCreator<PlatformStore> = (set) => {
  return {
    ...INITIAL_PLATFORM_STATE,
    setPlatform: (platform) => handleSetPlatform(set, platform),
    resetState: () => handleResetState(set),
  };
};
